module.exports = __webpack_public_path__ + "static/media/selo-agua.6babb48a.png";